import React, { memo } from 'react'

import ResultsTabletQuestionnaire from '../components/ResultsTabletQuestionnaire'
import TableCell from 'components/commons/TableCell'
import StatusSelect from 'components/commons/StatusSelect'
import SelectAndApplyQuestionnarie from '../components/SelectAndApplyQuestionnarie'

const styleStatusButton = {
   publicado: {
      display: 'inline-flex',
      alignItems: 'center',
      backgroundColor: 'rgba(55,200,70,0.15)',
      color: '#37C846',
      padding: '4px 14px',
      borderRadius: '40px'
   },
   publicado_dot: {
      height: '12px',
      width: '12px',
      borderRadius: '50%',
      backgroundColor: '#37C846',
      display: 'inline-block'
   },

   draft: {
      display: 'inline-flex',
      alignItems: 'center',
      backgroundColor: '#EF88331A',
      color: '#EF8833',
      padding: '4px 14px',
      borderRadius: '40px'
   },

   draft_dot: {
      height: '12px',
      width: '12px',
      borderRadius: '50%',
      backgroundColor: '#EF8833',
      display: 'inline-block'
   },

   programmed: {
      display: 'inline-flex',
      alignItems: 'center',
      backgroundColor: '#3264DC1A',
      color: '#3264DC',
      padding: '4px 14px',
      borderRadius: '40px'
   },

   programmed_dot: {
      height: '12px',
      width: '12px',
      borderRadius: '50%',
      backgroundColor: '#3264DC',
      display: 'inline-block'
   },
   idle: {
      display: 'inline-flex',
      alignItems: 'center',
      backgroundColor: '#B0002026',
      color: '#FF3A60',
      padding: '4px 14px',
      borderRadius: '40px'
   },

   idle_dot: {
      height: '12px',
      width: '12px',
      borderRadius: '50%',
      backgroundColor: '#FF3A60',
      display: 'inline-block'
   }
}

function ChipPublishedButton({ status }) {
   return (
      <span style={styleStatusButton?.publicado}>
         <span style={styleStatusButton.publicado_dot} />
         &nbsp;{status}
      </span>
   )
}
function ChipDraftButton({ status }) {
   return (
      <span style={styleStatusButton?.draft}>
         <span style={styleStatusButton.draft_dot} />
         &nbsp;{status}
      </span>
   )
}
function ChipProgrammedButton({ status }) {
   return (
      <span style={styleStatusButton?.programmed}>
         <span style={styleStatusButton?.programmed_dot} />
         &nbsp;{status}
      </span>
   )
}
function ChipIdleButton({ status }) {
   return (
      <span style={styleStatusButton?.idle}>
         <span style={styleStatusButton?.idle_dot} />
         &nbsp;{status}
      </span>
   )
}

const statusQuestionnaire = status => {
   switch (status) {
      case 'BORRADOR':
         return <ChipDraftButton status={status} />
      case 'PUBLICADO':
         return <ChipPublishedButton status={status} />
      case 'PROGRAMADO':
         return <ChipProgrammedButton status={status} />
      case 'INACTIVO':
         return <ChipIdleButton status={status} />
      default:
         return <ChipPublishedButton />
   }
}

const QuestionnaireTable = ({
   setViewQuestionnarie,
   allActiveRoles,
   allActiveGroups,
   isSearch,
   order,
   questionnaires,
   searchQuestionnaire,
   actionEdit,
   cleanCallback,
   onSubmitCallback
}) => {
   const columns = [
      {
         title: 'NOMBRE CUESTIONARIO',
         field: 'name',
         align: 'center',
         sorting: !!isSearch,
         customSort: () => 0,
         defaultSort: order,
         render: rowData => <TableCell text={rowData?.name} />
      },
      {
         title: 'VERSION',
         align: 'center',
         defaultSort: order,
         render: rowData => <TableCell text={rowData?.version} />
      },
      {
         title: 'NOMBRE DE USUARIO',
         field: 'createdBy',
         align: 'center',
         sorting: false,
         render: rowData => <TableCell text={rowData?.createdBy} />
      },
      {
         title: 'FECHA DE REGISTRO',
         field: 'createdDate',
         align: 'center',
         sorting: false,
         render: rowData => <TableCell text={rowData?.createdDate} />
      },
      {
         title: 'ESTADO',
         field: 'status',
         sorting: false,
         align: 'center',
         render: rowData => (
            <StatusSelect onSubmitCallback={onSubmitCallback} data={rowData} />
         )
      },
      {
         title: 'SUBDOMINIO',
         field: 'subdomain',
         sorting: false,
         align: 'center',
         render: rowData => <TableCell text={rowData?.subdomain?.name} />
      },
      {
         title: 'APLICACIÓN',
         field: 'application',
         sorting: false,
         align: 'center',
         render: rowData => <TableCell text={rowData?.application?.name} />
      },
      {
         title: 'TIPO DE USUARIO',
         field: 'module.name',
         sorting: false,
         align: 'center',
         render: rowData => (
            <SelectAndApplyQuestionnarie
               isForm={false}
               popperButtonText="Selecciona"
               allActiveRoles={allActiveRoles}
               allActiveGroups={allActiveGroups}
               previousAppliedItemsListRoles={rowData.roles}
               previousAppliedItemsListGroups={rowData.groups}
               subdomainCode={rowData.subdomain?.code}
               applicationCode={rowData.application?.code}
               questionnaireId={rowData.id}
               onSubmitCallback={onSubmitCallback}
               statusQuestionnaire={rowData.status}
            />
         )
      }
   ]

   return (
      <ResultsTabletQuestionnaire
         columns={columns}
         tableData={questionnaires}
         isSearch={isSearch}
         searchCallback={searchQuestionnaire}
         cleanCallback={cleanCallback}
         actionEdit={actionEdit}
         order={order}
         callVideo={true}
         setViewQuestionnarie={setViewQuestionnarie}
      />
   )
}

export default memo(QuestionnaireTable)
